import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';

import { Message } from '../../models/Message';
import { ITableColumn } from '../../shared/table/table.component';
import { MessageService } from '../../services/message.service';
import { MessageEditComponent } from './message-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'app-message-list',
	templateUrl: './message-list.component.html',
	styleUrls: ['./messages.component.scss']
})
export class MessageListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: MessageService,
        private modal: NgbModal
    ) { }

	groupSearchValue: string;
	codeSearchValue: string;
	titleSearchValue: string;
	textLvSearchValue: string;
	textEnSearchValue: string;

    page = 1;
    isFiltering: boolean;
    items: Message[] = [];

    readonly columns: ITableColumn[] = [
        { property: 'Code', label: 'messages_colCode', sorts: true },
        { property: 'TextLV', label: 'messages_colTextLv' },
        { property: 'TextEN', label: 'messages_colTextEn' },
        { width: '1px' }
    ];

    get isFiltered(): boolean {
        return !!(this.groupSearchValue || this.codeSearchValue || this.titleSearchValue || this.textEnSearchValue || this.textLvSearchValue);
    }

    private readonly filterSubj = new Subject<string>();

    ngOnInit() {
        this.filterSubj.pipe(debounceTime(300)).subscribe(() => {
            this.isFiltering = true;
            this.fetch();
        });

        this.fetch();
	}

    add() {
        this.edit(<Message>{});
    }

    edit(item: Message) {
        const ref = this.modal.open(MessageEditComponent, { size: 'lg' });
        ref.componentInstance.data = item;
        ref.result.then(() => {
            this.fetch();
        }, () => { });
    }

	filter() {
        this.filterSubj.next();
	}

    delete(item: Message) {
        this.app.confirm(this.app.translate('confirmItemDelete'), result => {
            if (!result) return;

            this.app.addLoading(this.service.delete(item.Id)).subscribe(() => {
                this.fetch();
            });
        });
    }

    splitMessage(text: string): string[] {
        const div = document.createElement('div');
        div.innerHTML = (text || '').replace(/<br\s?\/?>/g, '...');

        const msg = div.textContent;
        const max = 30;

        if (msg.length > max) {
            const rows = [];

            // max 3 rows
            for (let i = 0; i < 3; i++) {
                const cut = msg.substring(i * max, i * max + max);

                if (cut) {
                    rows.push(cut);
                }
            }

            if (rows.length) {
                rows[rows.length - 1] += '...';
            }

            return rows;
        }

        return [msg];
    }

    private fetch() {
        const filter = {
            group: this.groupSearchValue || '',
            code: this.codeSearchValue || '',
            title: this.titleSearchValue || '',
            textLv: this.textLvSearchValue || '',
            textEn: this.textEnSearchValue || ''
        };

        const request = this.service.get(this.isFiltered ? filter : null);

        this.app.addLoading(request).subscribe(data => {
            if (this.isFiltering) {
                this.page = 1;
                this.isFiltering = false;
            }
            
            this.items = data;
        });
    }
}
